import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AccordionItem from '~components/ui/AccordionItem'
import classNames from 'classnames'

class Accordion extends Component {
  constructor () {
    super()

    this.state = {
      activeItem: 0
    }
  }

  onClick (index, e) {
    e.preventDefault()

    let activeItem = index

    if (this.state.activeItem === activeItem) {
      activeItem = null
    }

    this.setState({ activeItem })
  }

  render () {
    return (
      <div className={classNames('border-b border-coral', this.props.className)}>
        {this.props.items.map(({ title, content }, index) => (
          <AccordionItem
            title={title}
            content={content}
            active={this.state.activeItem === index}
            onClick={this.onClick.bind(this, index)}
            key={`accordion-${index}`}
          />
        ))}
      </div>
    )
  }
}

Accordion.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string
  })),
  className: PropTypes.string
}

export default Accordion
